import { type OrderFrequency, type PackagingPreference, type ProductDetailsSticksData } from "@jti/fe-common";

export const getCurrentCategorySkusFromSticksMatrix = (
  packagingPreference: PackagingPreference,
  orderFrequency: OrderFrequency,
  data: ProductDetailsSticksData | undefined
) => {
  return data ? data[packagingPreference][orderFrequency].map((item) => item.sku) : [];
};
